import { useRef, useEffect } from "react";
// @ts-ignore
import mapboxgl from "!mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import styled from "@emotion/styled";
import { globalSettings } from "../../../../models/Settings";

const MapContainer = styled.div`
  overflow: clip;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .mapboxgl-marker {
    cursor: move;
  }
`;

type Props = {
  lng: number;
  lat: number;
  onChange?: (e: { lng: number; lat: number }) => void;
};
export default function StoreMap({ lng, lat, onChange }: Props) {
  const mapContainer = useRef(null);
  const markerContainer = useRef(null);
  const map = useRef<mapboxgl.Map>();
  const marker = useRef<mapboxgl.Marker>();

  mapboxgl.accessToken = globalSettings.settings.mapBox.mapBoxAccessToken;

  useEffect(() => {
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: 14,
      attributionControl: false
    });
    marker.current = new mapboxgl.Marker({
      draggable: true
    })
      .setLngLat([lng, lat])
      .addTo(map.current);
  }, []);

  useEffect(() => {
    if (onChange) {
      const handleDrag = (e: any) => {
        const { lat, lng } = e.target.getLngLat();
        onChange({
          lng: Number(lng.toFixed(7)),
          lat: Number(lat.toFixed(7))
        });
      };
      marker.current.on("dragend", handleDrag);
      return () => marker.current.off("dragend", handleDrag);
    }
  }, [onChange]);

  useEffect(() => {
    try {
      map.current.flyTo({
        center: [lng, lat]
      });
      marker.current.setLngLat([lng, lat]);
    } catch (e) {
      console.error(e);
    }
  }, [lng, lat]);

  return (
    <>
      <MapContainer ref={mapContainer} className="map-container" />
      <div ref={markerContainer} />
    </>
  );
}
